<mat-card style="background-color: #fff; border: 1px solid #c8c8c8; min-height: 400px">

  <app-chartjs *ngFor="let d of data; let i = index" [data]="d | async" [id]="i"></app-chartjs>


</mat-card>
